import React from 'react'
import Helmet from 'react-helmet'

import Layout from '../components/layout'
//import Lightbox from 'react-images'
import Gallery from '../components/Gallery'
import Footerbottom from '../components/Footerbottom'

import thumb01 from '../assets/images/thumbs/dakkapel-1.jpg'
import thumb02 from '../assets/images/thumbs/eikenvloer-2.jpg'
import thumb03 from '../assets/images/thumbs/garage-1.jpg'
import thumb04 from '../assets/images/thumbs/haard-3.jpg'
import thumb05 from '../assets/images/thumbs/keralit-3.jpg'
import thumb06 from '../assets/images/thumbs/tegelwerk-1.jpg'

import full01 from '../assets/images/fulls/dakkapel-1.jpg'
import full02 from '../assets/images/fulls/eikenvloer-2.jpg'
import full03 from '../assets/images/fulls/garage-1.jpg'
import full04 from '../assets/images/fulls/haard-3.jpg'
import full05 from '../assets/images/fulls/keralit-3.jpg'
import full06 from '../assets/images/fulls/tegelwerk-1.jpg'

const DEFAULT_IMAGES = [
  {
    id: '1',
    source: full01,
    thumbnail: thumb01,
    caption: 'Recent vakwerk',
    description: 'Plaatsen van dakkapel.',
  },
  {
    id: '2',
    source: full02,
    thumbnail: thumb02,
    caption: 'Recent vakwerk',
    description: 'Eikenvloer leggen.',
  },
  {
    id: '3',
    source: full03,
    thumbnail: thumb03,
    caption: 'Recent vakwerk',
    description: 'Interne verbouwing van garage.',
  },
  {
    id: '4',
    source: full04,
    thumbnail: thumb04,
    caption: 'Recent vakwerk',
    description: 'Een antieke haard plaatsen.',
  },
  {
    id: '5',
    source: full05,
    thumbnail: thumb05,
    caption: 'Recent vakwerk',
    description: 'Keralit plaatsen.',
  },
  {
    id: '6',
    source: full06,
    thumbnail: thumb06,
    caption: 'Recent vakwerk',
    description: 'Tegelwerk vloeren en wanden.',
  },
]

//url of contact-form-api
const url =
  'https://x4hsn6re20.execute-api.eu-west-1.amazonaws.com/dev/email/send'

function post(url, body, callback) {
  var req = new XMLHttpRequest()
  req.open('POST', url, true)
  req.setRequestHeader('Content-Type', 'application/json')
  req.addEventListener('load', function() {
    if (req.status < 400) {
      callback(null, JSON.parse(req.responseText))
    } else {
      callback(new Error('Request failed: ' + req.statusText))
    }
  })
  req.send(JSON.stringify(body))
  let toast = document.querySelector('.toast')
  toast.innerHTML = 'Even geduld....'
}
function success() {
  let toast = document.querySelector('.toast')
  toast.innerHTML = 'Succesvol verzonden'
}
function error(err) {
  let toast = document.querySelector('.toast')
  toast.innerHTML = 'Er ging iets mis: ' + err
  console.log(err)
}

class HomeIndex extends React.Component {
  //initialize each formfield otherwise React cannot process those.
  state = {
    name: '',
    phone: '',
    emailsender: '',
    subject: '',
    message: '',
  }

  handleInputChange = event => {
    const target = event.target
    const value = target.value
    const name = target.name
    this.setState({
      [name]: value,
    })
  }

  handleSubmit = event => {
    event.preventDefault()

    //manually compose the JSON payload that must be submitted to the Emailengine
    // name, emailsender and subject are mandatory!
    const payload = {
      name: this.state.name,
      phone: this.state.phone,
      emailsender: this.state.emailsender,
      subject: this.state.subject,
      message: this.state.message,
    }

    //reset status after the payload has been forwarded to the Emailengine
    this.setState({
      name: '',
      phone: '',
      emailsender: '',
      subject: '',
      message: '',
    })

    post(url, payload, function(err, res) {
      if (err) {
        return error(err)
      }
      success()
    })
  }

  render() {
    const siteTitle = 'Albert Steijger Allround Timmerwerk'
    const siteDescription = 'Albert Steijger Allround Timmerwerk website'

    return (
      <Layout>
        <Helmet>
          <title>{siteTitle}</title>
          <meta name="description" content={siteDescription} />
        </Helmet>

        <div id="main">
          <section id="one">
            <header className="major">
              <h2>Albert Steijger Allround Timmerwerk&copy;</h2>
            </header>
            <p></p>
            <p>
              Mijn naam is Albert Steijger. Ik ben allround timmerman met ruim
              30 jaar ervaring in de verbouw en renovatie. Mijn kracht zit in
              het meedenken en uitvoeren van creatieve oplossingen.
            </p>
            <p>
              U kunt bij mij terecht voor al uw kleine en middelgrote plannen en
              ideeën. Van vloeren leggen tot keukens of dakkappellen plaatsen.
              Maar ook voor de kleine klusjes zoals gordijnen ophangen of al die
              andere karweitjes waar u zelf soms de handigheid of het
              gereedschap niet voor heeft.
            </p>
            <p>
              Wat u ook graag wilt, bel vooral voor overleg. Dan kijken we samen
              hoe ik iets voor u kan maken.
            </p>
            <p>
              <img
                src="./images/as_van_450.png"
                alt="logo albert-timmerwerk.nl"
              />
            </p>
            <p>
              <a href="/#three">Voorbeelden van mijn werk</a> |{' '}
              <a href="/#four">Contact opnemen</a>
            </p>
          </section>
          <section id="two">
            <h2>Garant voor vakmanschap</h2>

            <ul className="actions">
              <li>Verbouw en renovatie</li>
              <li>Plaatsen keuken</li>
              <li>Installeren badkamer en toilet</li>
              <li>Tegelwerk</li>
              <li>Afhangen van deuren</li>
              <li>Plaatsen schuifpui of uitbouw</li>
              <li>Plaatsen dakkapel</li>
              <li>Plaatsen wanden en plafonds</li>
              <li>Onderhoud</li>
              <li>Timmerwerk</li>
              <li>Vloeren leggen</li>
            </ul>
          </section>
          <section id="three">
            <h2>Mijn werk</h2>

            <Gallery
              images={DEFAULT_IMAGES.map(
                ({ id, source, thumbnail, caption, description }) => ({
                  source,
                  thumbnail,
                  caption,
                  description,
                })
              )}
            />

            <ul className="actions">
              <li>
                <a href="./portfolio/" className="button">
                  Meer voorbeelden
                </a>
              </li>
            </ul>
          </section>
          <section id="four">
            <h2>Contact opnemen</h2>
            <p>Ik neem binnen enkele werkdagen contact met U op.</p>
            <div className="row">
              <div className="8u 12u$(small)">
                <form id="contactForm" onSubmit={this.handleSubmit}>
                  <div className="row uniform 50%">
                    <div className="6u 12u$(xsmall)">
                      <input
                        type="text"
                        placeholder="Naam"
                        name="name"
                        value={this.state.name}
                        onChange={this.handleInputChange}
                        aria-label="Naam"
                        required
                      />
                    </div>
                    <div className="6u 12u$(xsmall)">
                      <input
                        type="text"
                        placeholder="Telefoon"
                        name="phone"
                        value={this.state.phone}
                        onChange={this.handleInputChange}
                        aria-label="Telefoon"
                        required
                      />
                    </div>
                    <div className="12u">
                      <input
                        type="email"
                        placeholder="Email adres "
                        name="emailsender"
                        value={this.state.emailsender}
                        onChange={this.handleInputChange}
                        aria-label="Email adres"
                        required
                      />
                    </div>
                    <div className="12u">
                      <input
                        type="text"
                        placeholder="Onderwerp"
                        name="subject"
                        value={this.state.subject}
                        aria-label="Onderwerp"
                        onChange={this.handleInputChange}
                        required
                      />
                    </div>
                    <div className="12u">
                      <textarea
                        rows="5"
                        placeholder="Bericht of vraag"
                        name="message"
                        value={this.state.message}
                        onChange={this.handleInputChange}
                        aria-label="Bericht of vraag"
                        required
                      ></textarea>
                    </div>
                  </div>
                  <ul className="actions">
                    <li>
                      <br />
                      <input
                        type="submit"
                        id="submit"
                        value="Stuur Bericht"
                        aria-label="Stuur Bericht"
                      />
                    </li>
                    <li>
                      <div id="toast" className="toast"></div>
                    </li>
                  </ul>
                </form>
              </div>
              <div className="4u 12u$(small)">
                <ul className="labeled-icons">
                  <li>
                    <h3 className="icon fa-home">
                      <span className="label">Adres</span>
                    </h3>
                    <a
                      href="https://g.page/albert-timmerwerk?share"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Albert Steijger
                      <br />
                      Lage Boeschoterweg 15
                      <br />
                      3886PS Garderen
                    </a>
                  </li>
                  <li>
                    <h3 className="icon fa-mobile">
                      <span className="label">Phone</span>
                    </h3>
                    Mobiel 06-36309684
                  </li>
                  <li>
                    <h3 className="icon fa-envelope-o">
                      <span className="label">Email</span>
                    </h3>
                    info@albert-timmerwerk.nl
                  </li>
                </ul>
              </div>
            </div>
          </section>
          <Footerbottom />
        </div>
      </Layout>
    )
  }
}

export default HomeIndex
